import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { Instagram } from "lucide-react";
import { galleryImages } from "../../mock";

export default function GallerySection() {
  return (
    <section className="bg-cream py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-5 lg:px-10">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <span className="divider-ornament">Visual Experience</span>
          <h2 className="font-display text-sea-deep text-4xl md:text-5xl lg:text-6xl font-medium mt-5 mb-4 leading-[1.1]">
            Gallery
          </h2>
          <p className="text-sea-mid/85 text-base md:text-lg leading-relaxed">
            A glimpse of the atmosphere, presentation and dining experience that makes
            every visit to Sea Spice Kitchen special.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {galleryImages.slice(0, 8).map((img, i) => (
            <div
              key={img.caption}
              className={`gallery-item bg-sea-deep ${
                i === 0 || i === 5 ? "lg:row-span-2 lg:h-[520px]" : "h-64 lg:h-[252px]"
              }`}
            >
              <img src={img.src} alt={img.caption} className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a2424]/85 via-transparent to-transparent opacity-0 group-hover:opacity-100" />
              <div className="absolute bottom-0 inset-x-0 p-4 text-white text-sm font-medium translate-y-2 group-hover:translate-y-0 transition-all">
                <span className="bg-[#0d2929]/85 backdrop-blur px-3 py-1.5 inline-block text-xs tracking-[0.2em] uppercase">
                  {img.caption}
                </span>
              </div>
            </div>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-14">
          <Link to="/gallery">
            <Button className="bg-sea-deep hover:bg-[hsl(184_60%_10%)] text-white rounded-none px-8 h-12 tracking-wide">
              View Full Gallery
            </Button>
          </Link>
          <a
            href="#"
            className="inline-flex items-center gap-2 text-sea-mid hover:text-spice-gold transition-colors text-sm tracking-wide"
          >
            <Instagram size={16} />
            Follow @seaspicekitchen on Instagram
          </a>
        </div>
      </div>
    </section>
  );
}
